import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchCats(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                    .post('/services/v1/category/list',data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addCategory(ctx,queryParams){
            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                    .post('/services/v1/category/add',data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateCategory(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                    .post('/services/v1/category/update/'+queryParams.id,data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteCategory(ctx,id){
            return new Promise((resolve, reject) => {
                axios
                    .delete('/services/v1/category/delete/'+id)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchServices(ctx,queryParams){
            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                    .post('/services/v1/list',data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addService(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post('/services/v1/add', data.formData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateService(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/services/v1/update`, data.formData, {
                    headers:{
                        'Content-Type': 'multipart/form-data',
                        'dataType':'json'
                    }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteService(ctx,id){
            return new Promise((resolve, reject) => {
                axios
                    .delete('/services/v1/delete/'+id)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateBlogsOrdering(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                    .post('/services/v1/updateOrdering', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchImages(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                    .post('/services/v1/image/getall',data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateOrdering(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                    .put('/services/v1/image/updateOrdering',data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        uploadimages(ctx,queryParams){
            return new Promise((resolve, reject) => {
                axios
                .post('/services/v1/image/add/'+queryParams.id,queryParams.formData)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        fetchImageDelete(ctx,id){
            return new Promise((resolve, reject) => {
                axios
                .delete('/services/v1/image/delete/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        fetchBlocks(ctx, queryParams) {
            const data =  queryParams.replace(/%22/g, '');
            return new Promise((resolve, reject) => {
                axios
                .get('/services/v1/contents/detail/'+data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        getCategoriesBySite(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
            axios
                .post('/services/v1/category/getallbysite',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}